// extracted by mini-css-extract-plugin
module.exports = {"fileThumbnail":"file-thumbnail-view_fileThumbnail__1AUko"};